export default "__VITE_ASSET__PlJbNNWx__"